export default (state = 'loading', action) => {
  switch (action.type) {
    case  'SET_SIGNED_IN':
      return true
    case  'SET_SIGNED_OUT':
      return false
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/authenticate.js